import { Link, useSearchParams } from 'react-router-dom';
import { getTranslation } from '../../constants/translations';
import { getRegion } from '../../helpers/getRegion';

import './Header.scss';
import { FC, useEffect } from 'react';
import classNames from 'classnames';
import { openLoginModal } from '../../helpers/openLoginModal';

type Props = {
  isMenuOpened: boolean;
  toggleMenu: () => void;
};

export const Header: FC<Props> = ({ isMenuOpened, toggleMenu }) => {
  const domen = getRegion();
  const t = getTranslation();
  const [serchParams] = useSearchParams();
  const isToken = !!serchParams.get('token');

  useEffect(() => {
    if (window.location.hash === '#login') {
      openLoginModal();
    }
  }, []);

  return (
    <header className="sixtix__header header">
      <div className="header__container _container">
        <Link className="header__logo-link" to="/">
          <img className="logo" src={`./${domen}/logo.png`} alt="SixTix" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 117.852 108.621"
            className="logo header__shadow-logo"
          >
            <path
              id="Logo_boje_wit"
              data-name="Logo boje_wit"
              d="M47.186,0V51.96H71.057V0Zm49.98,0-1.38,7.007L94.366,0H74.715V21.768l9.844,4.193-9.844,4.231V51.96H94.366l1.42-7.031,1.38,7.031h19.689V30.192l-9.844-4.231,9.844-4.193V0ZM0,55.661V79.543H7.034v28.078H36.491V79.543h7.044V55.661H0Zm47.183,0v51.96H71.057V55.661Zm49.98,0-1.38,7.007-1.42-7.007H74.715V77.429l9.844,4.193-9.844,4.231v21.768H94.366l1.42-7.031,1.38,7.031h19.689V85.853l-9.844-4.231,9.844-4.193V55.661ZM43.538,18.968H33.694l9.844-4.231V0H14.03A13.557,13.557,0,0,0,4.123,4.121,13.478,13.478,0,0,0,.005,14.04V33.008H9.85L.005,37.228V51.963H29.5a14.069,14.069,0,0,0,14.04-14.04V18.968h0Z"
              transform="translate(0.497 0.5)"
              fill="none"
              stroke="#000000"
              strokeWidth="0.5"
            />
          </svg>
        </Link>

        {!isToken && (
          <div className="header__buttons-container">
            <button
              className="header__button header__button--login button"
              onClick={openLoginModal}
            >
              {t.common.login}
            </button>
            <a
              href={`mailto:info@sixtix.${domen}`}
              className="header__button header__button--lost button"
              target="_blank"
              rel="noreferrer"
            >
              {t.common.lostTicket}
            </a>
          </div>
        )}

        {!isToken && (
          <div
            className={classNames('burger-button', {
              'burger-button--closed': isMenuOpened,
            })}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        )}
      </div>
    </header>
  );
};
